import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import logoCircle from "../../Assets/logo_circle.png";
import logoWoOutline from "../../Assets/logo_wo_outline.png";
import Particle from "../Particle";
import Home2 from "./Home2";
import Home3 from "./Home3";
import Type from "./Type";
import Tilt from "react-parallax-tilt";

function Home() {
  const [isMobile, updateSize] = useState(false);

  function resizeHandler() {
    let currentSize = window.innerHeight
    let mobileSize = 760;
    if (currentSize >= mobileSize) {
      updateSize(true)
    } else {
      updateSize(false)
    }
  }

  window.addEventListener("resize", resizeHandler);

  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 10 }} className="heading">
                Welcome to
              </h1>

              <h1 style={{ paddingBottom: 50 }} className="heading-name">
                <strong className="main-name"> Song of Songs Entertainment</strong>
              </h1>

              <h3 style={{color: '#979797'}}>
                Entertain your wedding guests and create memorable moments during your wedding reception, wedding party, or even the ceremony itself.
              </h3>

              <div style={{ paddingTop: 30, paddingBottom: 30, textAlign: "left" }}>
                <Type />
              </div>
            </Col>

            <Col md={5} style={{marginTop: 30}}>
              <img src={logoCircle} alt="home pic" className="img-fluid" />
            </Col>
          </Row>
          
          {/* <Row>
            <Col md={8} className="home-about-description">
              <h1 style={{ fontSize: "2.6em", textAlign: "left" }}>
                Create memorable moments with <span className="purple"> Song of Songs </span>
              </h1>
              <p className="home-about-body">
                We are an entertain, artist-driven talent agency Found in 2021, based in Jakarta. Your solution for: Wedding, Events, Birthday Party, Corporate/private parties, etc. We entertain your guests with soulful, melodies and romantic wedding songs performed with all music genres.
              </p>
            </Col>
            <Col md={4} className="myAvtar">
              <Tilt>
                <img src={logoWoOutline} className="img-fluid" alt="avatar" />
              </Tilt>
            </Col>
          </Row> */}

        </Container>
      <Home2 />
      <Home3 />
      </Container>
    </section>
  );
}

export default Home;
